export default __webpack_public_path__ + "static/media/benefit2.24e4aaa6.svg";